import "./pagebuilder.css";
import { initJumpLinks, hasJumpLinks } from "@solvari/components";

function main() {
  if (hasJumpLinks) {
    initJumpLinks();
  }
}

main();
